export const AUTH_TOKEN = 'authToken';
export const GOOGLE_TOKEN = 'googleToken';
export const APPLE_CODE = 'appleCode';
export const BLOCK_AUTO_REFRESH_PAGE = 'blockRefresh';
